'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'alarm-clock';
var width = 512;
var height = 512;
var aliases = [9200];
var unicode = 'f34e';
var svgPathData = ['M18.7 480L64 525.3c13-13 32.3-32.3 57.9-57.8 37.4 28 83.8 44.6 134.1 44.6s96.8-16.6 134.2-44.6l57.8 57.8 45.3-45.3-57.8-57.8c28-37.4 44.6-83.8 44.6-134.2 0-123.7-100.3-224-224-224S32 164.3 32 288C32 338.3 48.6 384.8 76.6 422.2 51 447.7 31.7 467 18.7 480zM232 160l48 0 0 118.1c38 38 60 60 65.9 65.9L312 377.9c-4.8-4.8-29.1-29.1-73-73l-7-7 0-137.9z', 'M346.2 31.3c62.1 21.8 113.9 65.6 146.1 121.9 12.3-16.1 19.7-36.2 19.7-58 0-52.6-42.6-95.2-95.2-95.2-28 0-53.2 12.1-70.6 31.3zM0 95.2C0 117.1 7.3 137.2 19.7 153.2 51.9 96.9 103.7 53.1 165.8 31.3 148.4 12.1 123.2 0 95.2 0 42.6 0 0 42.6 0 95.2zM280 184l0-24-48 0 0 137.9 7 7c43.8 43.8 68.2 68.2 73 73L345.9 344c-6-6-28-28-65.9-65.9l0-94.1z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faAlarmClock = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;